import { render, staticRenderFns } from "./ServiceObjectMapPopupReports.vue?vue&type=template&id=2ece675b&"
import script from "./ServiceObjectMapPopupReports.vue?vue&type=script&lang=js&"
export * from "./ServiceObjectMapPopupReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QSpinnerDots,QBanner,QIcon,QInnerLoading,QSpinnerGears,QExpansionItem,QItem,QItemSection,QItemLabel} from 'quasar'
component.options.components = Object.assign({QBtn,QSpinnerDots,QBanner,QIcon,QInnerLoading,QSpinnerGears,QExpansionItem,QItem,QItemSection,QItemLabel}, component.options.components || {})
